export const ToPrinter = async (data) => {
  fetch("http://localhost:5000/print", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
